import axios from "axios";

export const API = axios.create({
   baseURL: "https://theblackbullfxadmin-api.skyapi.store/",
   //baseURL: "http://localhost:2895/",
});
